var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#ee4c68",
    opacity: 1,
    "data-original": "#ee4c68",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353944",
    d: "M106.3 99.2V78.7c-1.6-4.1-3.2-4.9-3.2-4.9-2-2.8-22.5-10.3-22.5-10.3l-2 .9-.4 1.4-3.7 12.9h-21l-3.7-12.9-.4-1.4-2-.9S26.9 71 24.9 73.8c0 0-1.6.8-3.2 4.9v20.5z",
    opacity: 1,
    "data-original": "#353944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0b97c",
    d: "M76.3 68.8H51.7c2.1-6.4 2.1-13.1 0-19.4h24.6c-2.1 6.3-2.1 13.1 0 19.4z",
    opacity: 1,
    "data-original": "#f0b97c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfeff",
    d: "M60.2 99.2H68l1.8-5.5 2.9-8.8L79 65.8H49.8l8.5 27.3z",
    opacity: 1,
    "data-original": "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1592f",
    d: "m70.7 99.2-.8-4.7-.1-.8-1.1-6.9-2.2-13.5h-5l-2.2 13.5-1 6.3-.2 1.4-.8 4.7z",
    opacity: 1,
    "data-original": "#f1592f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8e7e8",
    d: "M64 65.8 74.8 60 72 72.2s-2.8-3.3-8-6.4z",
    opacity: 1,
    "data-original": "#e8e7e8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e34e30",
    d: "m69.6 69.8-3.1 3.5h-5l-3.1-3.5c1.3-1.2 3.2-2.6 5.6-4 2.4 1.4 4.2 2.8 5.6 4z",
    opacity: 1,
    "data-original": "#e34e30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656d7a",
    d: "m71.8 99.2 9.7-19.5-4.2-1.9 5.1-3.4-1.8-10.9-5.8-3.6-.1.3-1.2 5.6h-.1l-.6 3-.8 3.4-3.3 14.6-2.8 12.4z",
    opacity: 1,
    "data-original": "#656d7a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8e7e8",
    d: "M64 65.8 53.2 60 56 72.2s2.8-3.3 8-6.4z",
    opacity: 1,
    "data-original": "#e8e7e8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656d7a",
    d: "m46.5 79.7 9.7 19.5h5.9l-2.8-12.4L56 72.2l-.8-3.4-.6-3-1.3-5.7-.1-.2-5.8 3.6-1.8 10.9 5.1 3.4z",
    opacity: 1,
    "data-original": "#656d7a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.2,
    cy: 35.3,
    fill: "#f0b97c",
    rx: 3,
    ry: 6.3,
    transform: "rotate(9.94 82.216 35.357)",
    opacity: 1,
    "data-original": "#f0b97c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0b97c",
    d: "M42.4 35.8c.6 3.4 2.4 5.9 4 5.7 1.6-.3 2.4-3.3 1.8-6.7-1.4-8.2-7.2-7.1-5.8 1z",
    opacity: 1,
    "data-original": "#f0b97c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7cfa3",
    d: "M82.6 31.4C82.6 47.6 70.5 60 63.7 60 57 60 44.8 47.6 44.8 31.4c0-10.9 8.5-24.9 18.9-24.9 10.5 0 18.9 14 18.9 24.9z",
    opacity: 1,
    "data-original": "#f7cfa3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353944",
    d: "M81.5 27.7c0 2.1-.4 4.1-1.1 6l2.7-.4c1.4-2.9 2.2-6.1 2.2-9.5 0-2.5-.4-5-1.2-7.2-1.1.8-2.7 1.8-4.7 2.7 1.3 2.5 2.1 5.4 2.1 8.4z",
    opacity: 1,
    "data-original": "#353944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d535f",
    d: "M85.8 14.9c0 .3-.6.9-1.8 1.8-1.1.8-2.7 1.8-4.7 2.7-11.4 5.4-25.3 3.2-31-.4-2.6 4.6-3 10.1-1.3 14.8l-2.7-.4C32.9 10.1 65.8-12.5 85.8 14.9z",
    opacity: 1,
    "data-original": "#4d535f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8e7e8",
    d: "M105.7 77.2H22.3c-2.2 0-4 1.8-4 4V128h91.4V81.2c0-2.2-1.8-4-4-4z",
    opacity: 1,
    "data-original": "#e8e7e8",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 102.6,
    r: 7.6,
    fill: "#d2d2d4",
    opacity: 1,
    "data-original": "#d2d2d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.589c4643550f1b0d9a58b12ef5846499.svg";
export { ForwardRef as ReactComponent };